import React from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import Table from '../../widgets/tables/Table';
import WaitDialog from '../../widgets/WaitDialog';

import GetAule from '../../services/getAule';
import DeleteAula from '../../services/deleteAula';
import SelectPdfDatesWidget from "../../widgets/SelectPdfDatesWidget";
import { NineCellLoading } from 'react-loadingg';
import translateString from "../../utils/Locales";
import Utils from "../../utils/utils";

let t = translateString;

export default class Corsi extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.selectRef = React.createRef();

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      waitDialogVisible: false,
      mailCompaniesList: [], 
      selectDateAulaVisible: false, 
      selectPdfDatesVisible: false,
      selectedAula: null, 
      pdfElem: null
    }

    this.grid = 2;

    this.pdfElements = [];

    this.aule = [];
    this.pageTitle = "Aule";
    this.brokerId = undefined;

    const cookies = new Cookies();
    this.dbPath = cookies.get('db_path', { path: '/' });
    var strJson = JSON.stringify({list: []});
    cookies.set('checksList', strJson, { path: '/' });

    this.state = {
        isLoading: true,
    };

  }

  async reload(){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    Utils.setAnalyticsPage('Classrooms list - ' + cookies.get('db', { path: '/' }));
    
    this.aule = await GetAule(username, token);
    this.aule = this.aule.filter (a => a.id != 0);
    this.aule.forEach((aula) => {
      aula.capienza = aula.capienza + ' ' + t('studenti').toUpperCase();
    })

    this.setState({ isLoading: false });
  }

  async componentDidMount(){
    await this.reload();

  }


  render () {

    var headCells = [
      { id: 'nome', numeric: false, disablePadding: true, label: t('nome') },
      { id: 'capienza', numeric: false, disablePadding: true, label: t('capienza') },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];  

    this.searchCols = ['nome'];

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />
    
    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('aule')} button={t('aggiungi')} onClick={() => {
          window.location.href =  '/' + this.dbPath + '/#/app/addAula';
        }}/>

        <Table headCells={headCells} searchCols={this.searchCols} excel={false} calendar={true} mail={false} pdf={true} rows={this.aule}

        onCalendarClick={(row) => {
            this.setState({ selectedAula: row, selectDateAulaVisible: true });
        }}

        onPdfClicked={(row) => {
          this.setState({
            selectPdfDatesVisible: true,
            pdfElem: row
        })

        }}

        onDelete={async (id) => {
          if (window.confirm(t('elimina_aula')) == false) return;

          const cookies = new Cookies();
          const username = cookies.get('username', { path: '/' });
          const token = cookies.get('token', { path: '/' });
          await DeleteAula(username, token, id);
          this.reload();
        }}

        onElementCheck={async (companyId) => {
          const cookies = new Cookies();

          var json = cookies.get('checksList', { path: '/' });
          var checksList = json.list;
          var index = checksList.indexOf(companyId);
          if (index != -1)
            checksList.splice(index, 1);
          else 
            checksList.push(companyId);

          cookies.set('checksList', JSON.stringify({list: checksList}), { path: '/' });
        }}

        />

        {this.elementPdf ? this.elementPdf : null}
        

        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index}/>

        { this.state.selectDateAulaVisible && (
          <SelectPdfDatesWidget show={this.state.selectDateAulaVisible} key={Math.random()}
          
          onCancel={() => this.setState({ selectDateAulaVisible: false }) }
          
          onOkClicked={(startDate, endDate) => {
                        
              const cookies = new Cookies();
              cookies.set('currentAula', this.state.selectedAula, { path: '/' });
              cookies.set('dateFrom', startDate, { path: '/' });
              cookies.set('dateTo', endDate, { path: '/' });
              window.location.href =  '/' + this.dbPath + '/#/app/detailAula';
          }} />
        )}

        { this.state.selectPdfDatesVisible && (
          <SelectPdfDatesWidget show={this.state.selectPdfDatesVisible} key={Math.random()}

          onCancel={() => this.setState({ selectPdfDatesVisible: false }) }
          
          onOkClicked={(startDate, endDate) => {
              const cookies = new Cookies();
              cookies.set('currentAula', this.state.pdfElem, { path: '/' });
              cookies.set('dateFrom', startDate, { path: '/' });
              cookies.set('dateTo', endDate, { path: '/' });
              window.location.href = '/' + this.dbPath + '/#/app/pdfAulaPage';
          }} />
        )}

        </LoadingOverlay>
      </>
    );
  }
}

